import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { GeckoEntry, RolodexEntryType } from 'types'

type LengthsInBins = {
  x: { length_in_bins: number }
  y: { length_in_bins: number }
}

export const useTotalUT = (inspectionIds: string[]): number => {
  const { entries } = useRolodexEntries(
    inspectionIds
      ? {
          type: RolodexEntryType.ADVANCED_SERVICES_SCAN,
          limit: 10000,
          tags: { inspection: inspectionIds },
        }
      : undefined
  )

  return useMemo(() => {
    const utReadings = entries
      .map((entry) => extractLengths(entry))
      .map((lengths) => lengths.x.length_in_bins * lengths.y.length_in_bins)
      .reduce((prev, curr) => curr + prev, 0)

    return utReadings
  }, [entries])
}

function extractLengths(entry: GeckoEntry) {
  return entry.raw.data as unknown as LengthsInBins
}
